/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Art_SourceInputs */

const en_svc_research_art_source = /** @type {(inputs: Svc_Research_Art_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospect brief`)
};

const lv_svc_research_art_source = /** @type {(inputs: Svc_Research_Art_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienta kopsavilkums`)
};

/**
* | output |
* | --- |
* | "Prospect brief" |
*
* @param {Svc_Research_Art_SourceInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_art_source = /** @type {((inputs?: Svc_Research_Art_SourceInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Art_SourceInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_art_source(inputs)
	return en_svc_research_art_source(inputs)
});